import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import IconRoundButton from "../CommonButtons/IconRoundButton";
import { IntervalConfiguration } from "../../../utils/configurationProvider";

const ReminderFlowTypeModal = ({
  closePanel,
  txnDetails,
  flowType,
  onInternalClick,
  onBeneClick,
}) => {
  const services = useSelector((state) => state.refreshToken.services);
  const navigate = useNavigate();
  const [animate, setAnimate] = useState(false);

  const hasCreateService = services?.includes(
    flowType === "Owner" ? "VBeneficiaryTxn" : "CBeneficiaryTxn",
  );
  const hasCreateInternalService = services?.includes(
    flowType === "Owner" ? "VInternalTxn" : "CInternalTxn",
  );
  return (
    <>
      <div
        className="fixed top-top-base left-left-base w-screen h-screen bg-PopUp-BackDrop opacity-80 z-[9998]"
        onClick={closePanel}
      ></div>
      <div className="flex justify-center items-center h-screen w-full fixed top-top-base left-left-base z-[9999] px-padding-button-l">
        <div
          className={`popup-container rounded-lg lg:py-padding-md px-padding-md md:py-padding-md py-padding-md pl-padding-md w-full overflow-y-auto animate-none ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"}`}
        >
          <div className="flex items-center justify-between w-full mb-margin-md">
            <div className="flex-1">
              <p className="text-font-lg font-sans font-semibold text-text-secondary">
                Select transaction type
              </p>
            </div>

            <IconRoundButton
              enabledBgColor={"var(--primary-nav-act)"}
              isLoading={false}
              handleFunction={() => {
                setAnimate(true);
                setTimeout(() => {
                  closePanel();
                }, IntervalConfiguration.intervalSemiMid);
              }}
              title="Close"
              icon={"https://q2pay.in/new_assets/common/create_flow/close.svg"}
              hoverOption="white"
              btnType={"button"}
              isDisabled={false}
            />
          </div>
          <div
            className={`w-full mb-margin-md p-padding-sm bg-primary-nav rounded-border-radius-md flex flex-row gap-3 justify-start items-center
                ${
                  hasCreateService
                    ? "cursor-pointer global-hover-white relative z-z-index-base"
                    : "cursor-not-allowed opacity-light-opacity"
                }`}
            onClick={() => {
              if (flowType === "Owner") {
                closePanel();
                onBeneClick();
              } else if (!hasCreateService) {
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "CBeneficiaryTxn",
                  },
                });
              } else {
                navigate(
                  "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
                  {
                    state: {
                      txnDetails: {
                        reminderRemark: txnDetails?.reminderRemark,
                        reminderAmount: txnDetails?.reminderAmount || "",
                      },
                      flowType: "ReminderFlow",
                    },
                  },
                );
              }
            }}
          >
            <img
              src={
                "https://q2pay.in/new_assets/common/home_dashboard_icons/beneficiary_transaction_with_blue_circle.svg"
              }
            />
            <p className="text-font-sm text-text-primary font-sans font-normal">
              Beneficiary Transactions{" "}
            </p>
          </div>
          <div
            className={`w-full p-padding-sm bg-primary-nav rounded-border-radius-md flex flex-row gap-3 justify-start items-center
                ${
                  hasCreateInternalService
                    ? "cursor-pointer global-hover-white relative z-z-index-base"
                    : "cursor-not-allowed opacity-light-opacity"
                }`}
            onClick={() => {
              if (flowType === "Owner") {
                closePanel();
                onInternalClick();
              } else if (!hasCreateInternalService) {
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "CInternalTxn",
                  },
                });
              } else {
                navigate(
                  "/internal_transaction_dashboard/create_internal_transaction",
                  {
                    state: {
                      txnDetails: {
                        reminderRemark: txnDetails?.reminderRemark,
                        reminderAmount: txnDetails?.reminderAmount || "",
                      },
                      flowType: "ReminderFlow",
                    },
                  },
                );
                sessionStorage.removeItem("recreate_int_txn_id");
              }
            }}
          >
            <img
              src={
                "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg"
              }
            />
            <p className="text-font-sm text-text-primary font-sans font-normal">
              Internal Transactions
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReminderFlowTypeModal;
